import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import useFetchSections from "../../hooks/useFetchSections";
import useFetchClasses from "../../hooks/useFetchClasses";
import { ApiUrl } from "../../../ApiUrl";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import ReactPaginate from "react-paginate";

const AdmAttendanceEntry = () => {
  const dateRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedMonths, setSelectedMonths] = useState({});
  const [attendanceData, setAttendanceData] = useState([]);
  const [assignmentDate, setAssignmentDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [attendanceStatus, setAttendanceStatus] = useState("");
  const [smsTo, setSmsTo] = useState("B");
  // const [smsTo, setSmsTo] = useState("F");
  const fromClassRef = useRef(null);
  const toClassRef = useRef(null);
  const admissionNoRef = useRef(null);
  const barcodeRef = useRef(null);
  const smsToRef = useRef(null);
  const [periods, setPeriods] = useState([]);
  const [formData, setFormData] = useState({
    classId: "",
    sectionId: "",
    feeappfrom: "",
    subject: "",
    teacher: "",
    studentName: "",
    admissionNo: "",
  });
  const [students, setStudents] = useState([]);
  const [error, setError] = useState("");
  const [subject, setSubject] = useState("");
  const [teacher, setTeacher] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const [selectedClassId, setSelectedClassId] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  const [filteredStudents, setFilteredStudents] = useState([]);
  const [tableVisible, setTableVisible] = useState(false);
  const [studentError, setStudentError] = useState("");
  const [subjectsList, setSubjectsList] = useState([]);
  const [teachersList, setTeachersList] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);
  const [isEditButtonEnabled, setIsEditButtonEnabled] = useState(false);
  const rowsPerPage = 10;
  const normalizeSelectValue = (value) =>
    value === null || value === undefined ? "" : String(value);
  const loggedInUserId = normalizeSelectValue(sessionStorage.getItem("userId"));
  const isStaffAttendanceRoute = location.pathname.startsWith("/staff/");

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const offset = currentPage * rowsPerPage;
  const currentRows = attendanceData.slice(offset, offset + rowsPerPage);
  const pageCount = Math.ceil(attendanceData.length / rowsPerPage);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = async () => {
    const userId = sessionStorage.getItem("userId");
    const academicSessionId = localStorage.getItem("academicSessionId");
    const selectedStudentClassId = normalizeSelectValue(formData.classId);
    const selectedStudentSectionId = normalizeSelectValue(formData.sectionId);
    const selectedPeriodId = normalizeSelectValue(formData.feeappfrom);
    const subjectId = localStorage.getItem("subjectId");
    const teacherId = localStorage.getItem("teacherId");
    const studentId = localStorage.getItem("studentId");

    const date = dateRef.current.value;

    const currentDate = new Date().toISOString().split("T")[0];
    if (date !== currentDate) {
      alert("Only today's attendance can be edited.");
      return;
    }

    for (let index = 0; index < attendanceData.length; index++) {
      const student = attendanceData[index];
      const { father_contact_number, mother_contact_number } = student;

      if (father_contact_number && father_contact_number.length !== 10) {
        alert(
          `Sl.No. ${index + 1}: Father's contact number for student ${student.studentId
          } should be exactly 10 digits.`
        );
        return;
      }

      if (mother_contact_number && mother_contact_number.length !== 10) {
        alert(
          `Sl.No. ${index + 1}: Mother's contact number for student ${student.studentId
          } should be exactly 10 digits.`
        );
        return;
      }

    }

    const studentsToSave = attendanceData.filter((student) => student.present);

    if (studentsToSave.length === 0) {
      alert("Please mark attendance for at least one student before saving.");
      return;
    }

    const updateDetails = studentsToSave.map((student) => {
      const markAttendance =
        student.present === "present"
          ? "P"
          : student.present === "absent"
            ? "A"
            : student.present === "leave"
              ? "L"
              : "";

      return {
        studentId: student.studentId,
        father_contact_number: student.father_contact_number,
        mother_contact_number: student.mother_contact_number,
        mark_Attendance: markAttendance,
        remarks: student.remarks,
        send_sms_to: smsTo,
      };
    });

    const payload = {
      loginId: userId,
      academic_year_id: academicSessionId,
      date: date,
      classId: selectedStudentClassId,
      sectionId: selectedStudentSectionId,
      claasPeriodId: selectedPeriodId,
      subjectId: subjectId,
      teacherId: teacherId,
      updateDetails: updateDetails,
    };

    console.log(payload);

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}StudentAttendance/CreateOrUpdateAttendance/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setIsEditing(false);
        alert("Attendance saved successfully!");
        console.log("Attendance saved successfully:", result);
      } else {
        alert(`Error saving attendance: ${result.message || "Unknown error"}`);
        console.error("Error saving attendance:", result);
      }
    } catch (error) {
      console.error("Error while making the API call:", error);

      alert(`Error while making the API call: ${error.message}`);
    }
  };

  const [showModal, setShowModal] = useState(false);
  const {
    classes,
    loading: classLoading,
    error: classError,
  } = useFetchClasses();

  const {
    sections,
    loading: sectionLoading,
    error: sectionError,
  } = useFetchSections(formData.classId);

  const [studentsData, setStudentsData] = useState([]);
  // const handleClassChange = (e) => {
  //   const classId = e.target.value;

  //   if (classId) {
  //     localStorage.setItem("selectedStudentClassId", classId);
  //   } else {
  //     localStorage.removeItem("selectedStudentClassId");
  //   }

  //   setFormData((prev) => ({
  //     ...prev,
  //     classId,
  //     sectionId: "",
  //   }));

  //   setSelectedClassId(classId);
  // };

  const handleClassChange = (e) => {
    const classId = normalizeSelectValue(e.target.value);

    // Update localStorage
    if (classId) {
      localStorage.setItem("selectedStudentClassId", classId);
    } else {
      localStorage.removeItem("selectedStudentClassId");
    }

    // Clear all form fields, attendance data and localStorage student info
    setFormData({
      classId: classId,
      sectionId: "",
      feeappfrom: "",
      subject: "",
      teacher: "",
      studentName: "",
      admissionNo: "",
    });

    setAttendanceData([]); // clear table data
    setFilteredStudents([]); // if used
    setTableVisible(false); // hide table if you're using this flag
    setSubject(""); // clear subject
    setTeacher(""); // clear teacher
    setAttendanceStatus(""); // reset radio group
    setStudentError(""); // reset error message if any
    setCurrentPage(0);
    setIsEditButtonEnabled(false); // disable Edit button when class changes

    // Remove stale entries from localStorage
    localStorage.removeItem("selectedStudentSectionId");
    localStorage.removeItem("selectedPeriodId");
    localStorage.removeItem("subjectId");
    localStorage.removeItem("teacherId");
    localStorage.removeItem("studentId");
  };

  // const handleSectionChange = (e) => {
  //   const sectionId = e.target.value;

  //   if (sectionId) {
  //     localStorage.setItem("selectedStudentSectionId", sectionId);
  //   } else {
  //     localStorage.removeItem("selectedStudentSectionId");
  //   }

  //   setFormData((prev) => ({ ...prev, sectionId }));
  // };

  const handleSectionChange = (e) => {
    const sectionId = normalizeSelectValue(e.target.value);

    if (sectionId) {
      localStorage.setItem("selectedStudentSectionId", sectionId);
    } else {
      localStorage.removeItem("selectedStudentSectionId");
    }

    // Clear period, subject, teacher selections and related localStorage
    localStorage.removeItem("selectedPeriodId");
    localStorage.removeItem("subjectId");
    localStorage.removeItem("teacherId");

    setFormData((prev) => ({
      ...prev,
      sectionId,
      feeappfrom: "", // clear selected period
      subject: "",
      teacher: "",
    }));

    setSubject("");
    setTeacher("");
    setSubjectsList([]);
    setTeachersList([]);
    setCurrentPage(0);
    setIsEditButtonEnabled(false); // disable Edit button when section changes
  };

  //New code 07312025
  const handleClear = () => {
    const retainedFields = [
      "academicSessionId",
      "branchId",
      "nextAcademicSessionId",
      "orgId",
    ];
    const retainedValues = {};

    // Save needed localStorage values
    retainedFields.forEach((key) => {
      retainedValues[key] = localStorage.getItem(key);
    });

    // Clear localStorage and restore only retained ones
    localStorage.clear();
    Object.keys(retainedValues).forEach((key) => {
      if (retainedValues[key] !== null) {
        localStorage.setItem(key, retainedValues[key]);
      }
    });

    // Clear form fields
    setFormData((prevData) => ({
      ...prevData,
      classId: "",
      sectionId: "",
      feeappfrom: "",
      subject: "",
      teacher: "",
    }));

    // Clear dropdowns
    setSubject("");
    setTeacher("");
    setSubjectsList([]);
    setTeachersList([]);

    // Clear table data
    setAttendanceData([]);

    // Disable Edit button when Clear is clicked
    setIsEditButtonEnabled(false);
  };

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  useEffect(() => {
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");

    const apiUrl = `${ApiUrl.apiurl}CLASS_PERIOD/GetCLASSPERIODLIST/${orgId}/${branchId}`;

    fetch(apiUrl)
      .then((response) =>
        response.ok ? response.json() : Promise.reject(response.status)
      )
      .then((data) => {
        setPeriods(data.data || []);
      })
      .catch(() => setError("Failed to load periods."));
  }, []);

  useEffect(() => {
    const academicSessionId = localStorage.getItem("academicSessionId");
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");
    const selectedStudentClassId = normalizeSelectValue(formData.classId);
    const selectedStudentSectionId = normalizeSelectValue(formData.sectionId);
    const selectedPeriodId = normalizeSelectValue(formData.feeappfrom);

    if (
      !selectedStudentClassId ||
      !selectedStudentSectionId ||
      !selectedPeriodId ||
      !assignmentDate
    ) {
      setSubjectsList([]);
      setTeachersList([]);
      setSubject("");
      setTeacher("");
      return;
    }

    if (formData.feeappfrom && assignmentDate) {
      const apiUrl = `${ApiUrl.apiurl}FILTER/GetSUBJECTTEACHERBASEDONPERIOD/?academic_year_id=${academicSessionId}&org_id=${orgId}&branch_id=${branchId}&date=${assignmentDate}&classId=${selectedStudentClassId}&sectionId=${selectedStudentSectionId}&claasPeriodId=${selectedPeriodId}`;

      fetch(apiUrl)
        .then((response) =>
          response.ok ? response.json() : Promise.reject(response.status)
        )
        .then((data) => {
          if (
            data.message === "success" &&
            Array.isArray(data.data) &&
            data.data.length > 0
          ) {
            const staffFilteredData = isStaffAttendanceRoute
              ? data.data.filter(
                  (item) =>
                    normalizeSelectValue(item.teacherId) === loggedInUserId
                )
              : data.data;

            if (staffFilteredData.length > 0) {
              const subjectOptions = staffFilteredData.map((item) => ({
                id: item.subjectId,
                name: item.subjectname,
              }));
              const teacherOptions = staffFilteredData.map((item) => ({
                id: item.teacherId,
                name: item.teachername,
              }));

              const matchedTeacherRow = staffFilteredData[0];
              const { subjectId, teacherId, subjectname, teachername } =
                matchedTeacherRow;
              localStorage.setItem("subjectId", subjectId);
              localStorage.setItem("teacherId", teacherId);

              setSubjectsList(subjectOptions);
              setTeachersList(teacherOptions);
              setSubject(subjectname);
              setTeacher(teachername);
            } else {
              // No matching entry for this staff
              const noEntryOption = { id: "", name: "No entry for this staff" };
              localStorage.setItem("subjectId", "");
              localStorage.setItem("teacherId", "");
              setSubjectsList([noEntryOption]);
              setTeachersList([noEntryOption]);
              setSubject("No entry for this staff");
              setTeacher("No entry for this staff");
            }
          } else {
            // No data case
            if (isStaffAttendanceRoute) {
              const noEntryOption = { id: "", name: "No entry for this staff" };
              localStorage.setItem("subjectId", "");
              localStorage.setItem("teacherId", "");
              setSubjectsList([noEntryOption]);
              setTeachersList([noEntryOption]);
              setSubject("No entry for this staff");
              setTeacher("No entry for this staff");
            } else {
              setSubjectsList([]);
              setTeachersList([]);
              setSubject("");
              setTeacher("");
            }
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
          if (isStaffAttendanceRoute) {
            const noEntryOption = { id: "", name: "No entry for this staff" };
            localStorage.setItem("subjectId", "");
            localStorage.setItem("teacherId", "");
            setSubjectsList([noEntryOption]);
            setTeachersList([noEntryOption]);
            setSubject("No entry for this staff");
            setTeacher("No entry for this staff");
          } else {
            setSubjectsList([]);
            setTeachersList([]);
            setSubject("");
            setTeacher("");
          }
          // Don’t set error that breaks UI — just let dropdown show fallback
        });
    }
  }, [
    assignmentDate,
    formData.classId,
    formData.sectionId,
    formData.feeappfrom,
    isStaffAttendanceRoute,
    loggedInUserId,
  ]);

  const handleInputChange = (e) => {
    if (!e || !e.target) {
      console.error("Invalid event object", e);
      return;
    }

    const { name, value } = e.target;
    const normalizedValue = normalizeSelectValue(value);

    setFormData((prevData) => ({
      ...prevData,
      [name]: normalizedValue,
    }));

    if (name === "feeappfrom") {
      localStorage.setItem("selectedPeriodId", normalizedValue);
      setIsEditButtonEnabled(false); // disable Edit button when period changes
    }
  };

  const handleDateChange = (e) => {
    const selectedDate = e.target.value;
    setAssignmentDate(selectedDate);
    localStorage.setItem("assignmentDate", selectedDate);
    setIsEditButtonEnabled(false); // disable Edit button when date changes
  };

  //08222025
  const fetchAttendanceData = async () => {
    const academicSessionId = localStorage.getItem("academicSessionId");

    // 🔹 Check if session changed
    const prevSessionId = localStorage.getItem("prevAcademicSessionId");
    if (prevSessionId && prevSessionId !== academicSessionId) {
      // Reset fields if session changed
      setFormData({
        classId: "",
        sectionId: "",
        feeappfrom: "",
        subject: "",
        teacher: "",
        studentName: "",
        admissionNo: "",
      });
      setSubject("");
      setTeacher("");
      setSubjectsList([]);
      setTeachersList([]);
      setAttendanceData([]);
      setIsEditButtonEnabled(false); // disable Edit button on session change

      // Clear localStorage selections
      localStorage.removeItem("selectedStudentClassId");
      localStorage.removeItem("selectedStudentSectionId");
      localStorage.removeItem("selectedPeriodId");
      localStorage.removeItem("subjectId");
      localStorage.removeItem("teacherId");
      localStorage.removeItem("studentId");

      // Update to current session
      localStorage.setItem("prevAcademicSessionId", academicSessionId);

      // alert("Academic session changed — please reselect Class, Section, Period, Subject and Teacher.");
      return; // ⛔ stop here, user must reselect
    } else if (!prevSessionId) {
      // First-time run: store the current session
      localStorage.setItem("prevAcademicSessionId", academicSessionId);
    }

    const date = dateRef.current.value;
    const classId = formData.classId;
    const sectionId = formData.sectionId;
    const periodId = formData.feeappfrom;

    if (!date) {
      alert("Please select a date.");
      setIsEditButtonEnabled(false); // disable Edit button if date is not selected
      return;
    }
    if (!classId) {
      alert("Please select a class.");
      setIsEditButtonEnabled(false); // disable Edit button if class is not selected
      return;
    }
    if (!sectionId) {
      alert("Please select a section.");
      setIsEditButtonEnabled(false); // disable Edit button if section is not selected
      return;
    }
    if (!periodId) {
      alert("Please select a period.");
      setIsEditButtonEnabled(false); // disable Edit button if period is not selected
      return;
    }

    const selectedDate = new Date(date);
    const currentDate = new Date();

    selectedDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    if (selectedDate > currentDate) {
      alert("You cannot view attendance for a future date.");
      setIsEditButtonEnabled(false); // disable Edit button if date is in future
      return;
    }

    const subjectId = localStorage.getItem("subjectId");
    const teacherId = localStorage.getItem("teacherId");

    const url = `${ApiUrl.apiurl}StudentAttendance/GetSearchAttendanceByDateclassperiod/?academic_year_id=${academicSessionId}&date=${date}&classId=${classId}&sectionId=${sectionId}&claasPeriodId=${periodId}&subjectId=${subjectId}&teacherId=${teacherId}`;

    try {
      const response = await fetch(url);
      const result = await response.json();

      if (result.message === "success") {
        const formattedData = result.data.map((student) => ({
          ...student,
          present:
            student.present === "P"
              ? "present"
              : student.present === "A"
                ? "absent"
                : student.present === "L"
                  ? "leave"
                  : "",
        }));

        setAttendanceData(formattedData);

        if (formattedData.length > 0) {
          const studentId = formattedData[0].studentId;
          localStorage.setItem("studentId", studentId);
          // Enable Edit button only if data is successfully loaded
          setIsEditButtonEnabled(true);
        } else {
          alert("No attendance records found for the selected criteria.");
          setIsEditButtonEnabled(false); // disable Edit button if no records returned
        }
      } else {
        alert("Failed to fetch data.");
        setIsEditButtonEnabled(false); // disable Edit button if fetch fails
      }
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      alert("An error occurred while fetching attendance data.");
      setIsEditButtonEnabled(false); // disable Edit button if error occurs
    }
  };

  const handleContactNumberChange = (studentId, field, value) => {
    setAttendanceData((prevData) =>
      prevData.map((student) =>
        student.studentId === studentId
          ? { ...student, [field]: value }
          : student
      )
    );
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                ATTENDANCE
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12  d-flex flex-wrap gap-2 ">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={fetchAttendanceData}
                  >
                    Display
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleEdit}
                    disabled={!isEditButtonEnabled || isEditing}
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSave}
                    disabled={!isEditing}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() =>
                      navigate(
                        isStaffAttendanceRoute
                          ? "/staff/dashboard"
                          : "/admin/dashboard"
                      )
                    }
                  >
                    Close
                  </button>
                </div>
              </div>
              <div className="row mt-3 mx-2">
                <div
                  className="col-12 custom-section-box"
                  style={{
                    minHeight: "260px",
                    padding: "20px",
                    backgroundColor: "#f9f9f9",
                    borderRadius: "8px",
                  }}
                >
                  <div className="row mt-3">
                    {/* Date */}
                    <div className="col-md-3 mb-3">
                      <label htmlFor="date" className="form-label">
                        Date <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        id="date"
                        className="form-control detail"
                        defaultValue={assignmentDate}
                        ref={dateRef}
                        onChange={handleDateChange}
                      />
                    </div>

                    {/* Class */}
                    <div className="col-md-3">
                      <label htmlFor="admitted-class" className="form-label">
                        Class <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="admitted-class"
                        className="detail"
                        classNamePrefix="react-select"
                        options={classes.map((classItem) => ({
                          value: classItem.id,
                          label: classItem.classname,
                        }))}
                        value={
                          classes
                            .map((classItem) => ({
                              value: classItem.id,
                              label: classItem.classname,
                            }))
                            .find(
                              (option) =>
                                String(option.value) ===
                                normalizeSelectValue(formData.classId)
                            ) || null
                        }
                        onChange={(selectedOption) =>
                          handleClassChange({
                            target: { value: selectedOption?.value },
                          })
                        }
                        placeholder="Select Class"
                      />
                    </div>

                    {/* Section */}
                    <div className="col-md-3">
                      <label htmlFor="admitted-section" className="form-label">
                        Admitted Section <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="admitted-section"
                        className="detail"
                        classNamePrefix="react-select"
                        options={sections.map((section) => ({
                          value: section.id,
                          label: section.sectionname,
                        }))}
                        value={
                          sections
                            .map((section) => ({
                              value: section.id,
                              label: section.sectionname,
                            }))
                            .find(
                              (option) =>
                                String(option.value) ===
                                normalizeSelectValue(formData.sectionId)
                            ) || null
                        }
                        onChange={(selectedOption) =>
                          handleSectionChange({
                            target: { value: selectedOption?.value },
                          })
                        }
                        placeholder="Select Section"
                      />
                    </div>

                    {/* Period */}
                    <div className="col-12 col-md-3 mb-1">
                      <label htmlFor="fee-app-from" className="form-label">
                        Period <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="fee-app-from"
                        className="detail"
                        classNamePrefix="react-select"
                        isDisabled={isDisabled}
                        options={
                          periods.length > 0
                            ? periods.map((period) => ({
                              value: period.id,
                              label: period.period_name,
                            }))
                            : [
                              {
                                value: "",
                                label: "No Periods Available",
                                isDisabled: true,
                              },
                            ]
                        }
                        value={
                          periods
                            .map((period) => ({
                              value: period.id,
                              label: period.period_name,
                            }))
                            .find(
                              (option) =>
                                String(option.value) ===
                                normalizeSelectValue(formData.feeappfrom)
                            ) || null
                        }
                        onChange={(selectedOption) =>
                          handleInputChange({
                            target: {
                              name: "feeappfrom",
                              value: selectedOption?.value,
                            },
                          })
                        }
                        placeholder="Select Period"
                      />
                    </div>

                    {/* Subject */}
                    <div className="col-md-3 mb-4">
                      <label htmlFor="subject" className="form-label">
                        Subject <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="subject"
                        className="detail"
                        classNamePrefix="react-select"
                        options={subjectsList.map((s) => ({
                          value: s.id,
                          label: s.name,
                        }))}
                        value={
                          subjectsList
                            .map((s) => ({
                              value: s.id,
                              label: s.name,
                            }))
                            .find((option) => option.label === subject) || null
                        }
                        onChange={(selectedOption) => {
                          localStorage.setItem(
                            "subjectId",
                            selectedOption ? selectedOption.value : ""
                          );
                          setSubject(selectedOption ? selectedOption.label : "");
                          setIsEditButtonEnabled(false); // disable Edit button when subject changes
                        }}
                        placeholder="Select Subject"
                      />
                    </div>
                    {/* Teacher */}
                    <div className="col-md-3">
                      <label htmlFor="teacher" className="form-label">
                        Teacher <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="teacher"
                        className="detail"
                        classNamePrefix="react-select"
                        isDisabled={isStaffAttendanceRoute}
                        options={teachersList.map((t) => ({
                          value: t.id,
                          label: t.name,
                        }))}
                        value={
                          teachersList
                            .map((t) => ({
                              value: t.id,
                              label: t.name,
                            }))
                            .find((option) => option.label === teacher) || null
                        }
                        onChange={(selectedOption) => {
                          localStorage.setItem(
                            "teacherId",
                            selectedOption ? selectedOption.value : ""
                          );
                          setTeacher(selectedOption ? selectedOption.label : "");
                          setIsEditButtonEnabled(false); // disable Edit button when teacher changes
                        }}
                        placeholder="Select Teacher"
                      />
                    </div>

                    {/* SMS + Attendance Row */}
                    <div className="row mb-3">
                      {/* Send SMS To Section */}
                      <div className="col-12 col-md-6 mb-3 mb-md-0">
                        <div className="border p-3 rounded h-100">
                          <div className="fw-bold mb-2">Send SMS to:</div>
                          <div className="d-flex flex-wrap gap-3">
                            <div className="d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="smsTo"
                                id="smsToFather"
                                checked={smsTo === "F"}
                                onChange={() => setSmsTo("F")}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="smsToFather"
                              >
                                Father
                              </label>
                            </div>
                            <div className="d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="smsTo"
                                id="smsToMother"
                                checked={smsTo === "M"}
                                onChange={() => setSmsTo("M")}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="smsToMother"
                              >
                                Mother
                              </label>
                            </div>
                            <div className="d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="smsTo"
                                id="smsToBoth"
                                checked={smsTo === "B"}
                                onChange={() => setSmsTo("B")}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="smsToBoth"
                              >
                                Both
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Attendance Status Section */}
                      <div className="col-12 col-md-6">
                        <div className="border p-3 rounded h-100">
                          <div className="fw-bold mb-2">Attendance Status:</div>
                          <div className="d-flex flex-wrap">
                            <div className="form-check me-4 mb-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="attendanceStatus"
                                id="markAllPresent"
                                checked={attendanceStatus === "present"}
                                onChange={() => {
                                  setAttendanceStatus("present");
                                  if (isEditing) {
                                    setAttendanceData((prevData) =>
                                      prevData.map((student) => ({
                                        ...student,
                                        present: "present",
                                      }))
                                    );
                                  }
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="markAllPresent"
                              >
                                Mark All Present
                              </label>
                            </div>
                            <div className="form-check mb-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="attendanceStatus"
                                id="markAllAbsent"
                                checked={attendanceStatus === "absent"}
                                onChange={() => {
                                  setAttendanceStatus("absent");
                                  if (isEditing) {
                                    setAttendanceData((prevData) =>
                                      prevData.map((student) => ({
                                        ...student,
                                        present: "absent",
                                      }))
                                    );
                                  }
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="markAllAbsent"
                              >
                                Mark All Absent
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <p
                    className="mb-0"
                    style={{
                      fontWeight: "bold",
                      textDecoration: "underline",
                      fontSize: "14px",
                    }}
                  >
                    Please Note:
                  </p>
                  <p className="mb-0" style={{ fontSize: "14px" }}>
                    1. Only current date Attendance can be edited.
                  </p>
                  <p style={{ fontSize: "14px" }}>
                    2. Past date and Current date Attendance can be viewed.
                  </p>
                </div>
              </div>

              {/* Table */}
              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered ">
                    <thead>
                      <tr>
                        <th>Sl.No</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Roll No</th>
                        <th>BarCode</th>
                        <th>Student Name</th>
                        <th>Primary Guardian</th>
                        <th>Father Mobile No</th>
                        <th>Mother Mobile No</th>
                        <th>Mark Attendance</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {attendanceData.length === 0 ? (
                        <tr>
                          <td colSpan="12" className="text-center">
                            No records found
                          </td>
                        </tr>
                      ) : (
                        currentRows.map((student, index) => (
                          <tr key={student.studentId}>
                            <td>{currentPage * rowsPerPage + index + 1}</td>
                            <td>{student.classname}</td>
                            <td>{student.sectionname}</td>
                            <td>{student.rollno || "N/A"}</td>

                            <td>{student.barcode}</td>
                            <td>{student.studentname}</td>
                            <td>{student.primary_guardian}</td>
                            <td>
                              <input
                                type="text"
                                className="form-control detail"
                                value={student.father_contact_number}
                                onChange={(e) =>
                                  handleContactNumberChange(
                                    student.studentId,
                                    "father_contact_number",
                                    e.target.value
                                  )
                                }
                                disabled={!isEditing}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control detail"
                                value={student.mother_contact_number}
                                onChange={(e) =>
                                  handleContactNumberChange(
                                    student.studentId,
                                    "mother_contact_number",
                                    e.target.value
                                  )
                                }
                                disabled={!isEditing}
                              />
                            </td>
                            <td>
                              <select
                                  className="form-select"
                                  value={student.present || ""}
                                  onChange={(e) =>
                                    handleContactNumberChange(
                                      student.studentId,
                                      "present",
                                      e.target.value
                                    )
                                  }
                                  disabled={!isEditing}
                                >
                                  <option value="">Mark Attendance</option>
                                  <option value="present">Present</option>
                                  <option value="absent">Absent</option>
                                  {/* <option value="leave">Leave</option> */}
                                </select>
                            </td>

                            <td>
                              <textarea
                                className="form-control detail"
                                value={student.remarks}
                                onChange={(e) =>
                                  handleContactNumberChange(
                                    student.studentId,
                                    "remarks",
                                    e.target.value
                                  )
                                }
                                disabled={!isEditing}
                                style={{
                                  resize: isEditing ? "both" : "none",
                                }}
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                  {attendanceData.length > rowsPerPage && (
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination justify-content-center mt-3"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
